import { Button } from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'
import { css } from 'emotion'
import React from 'react'

const smallButton = css`
  padding: 0px 8px !important;
  min-height: 15px !important;
  margin-left: 0.5rem !important;
`

export const SmallButton = (props: ButtonProps) => {
  return (
    <Button
      component="span"
      classes={{ root: smallButton }}
      variant="contained"
      {...props}
    />
  )
}
